import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoControlsComponent } from './components/video-controls/video-controls.component';
import { PlayPauseButtonComponent } from './components/play-pause-button/play-pause-button.component';
import { ProgressScrubberComponent } from './components/progress-scrubber/progress-scrubber.component';
import { IconModule } from 'studio-components/icon/icon.module';
import { ButtonLegacyModule } from 'studio-components/button-legacy/button-legacy.module';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { TimeIndicatorComponent } from './components/time-indicator/time-indicator.component';
import { DownloadButtonComponent } from './components/download-button/download-button.component';

const components = [
  PlayPauseButtonComponent,
  VideoControlsComponent,
  ProgressScrubberComponent,
  TimeIndicatorComponent,
  DownloadButtonComponent,
];

@NgModule({
  declarations: components,
  imports: [CommonModule, IconModule, ButtonLegacyModule, MatSliderModule],
  exports: components,
})
export class VideoControlsModule {}
